import React from 'react';
import styled from '@xstyled/styled-components';
import { t } from 'ttag';
import PlusIcon from '~/assets/icons/plus.svg';
import { useEditorStore } from '~/shell/Store';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import { duplicateTab } from '~/training/sequence/templates/items/tab/duplicateTabUtils';
import type { TabItem } from '~/training/sequence/templates/items/tab/types';

const DuplicateButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #9738ff;
    flex-shrink: 0;
  }

  &:hover svg {
    opacity: 0.7;
  }
`;

interface DuplicateTabButtonProps {
  className?: string;
  tabItems?: TabItem[] | null;
}

export const DuplicateTabButton: React.FC<DuplicateTabButtonProps> = ({
  className,
  tabItems
}) => {
  const { sequence, addSubItem } = useEditorStore();
  const { setActiveTab } = useSequenceStore();

  const handleDuplicateLatestTab = () => {
    if (!sequence || !tabItems || tabItems.length === 0) return;

    const latestTab = tabItems.reduce((latest: TabItem, current: TabItem) =>
      (current.position ?? 0) > (latest.position ?? 0) ? current : latest
    );

    const tabPositions = tabItems.map((it: TabItem) => it.position ?? 0);
    const maxPosition = Math.max(...tabPositions);
    const nextPosition = maxPosition + 1;

    duplicateTab(latestTab, nextPosition, sequence.id, addSubItem);
    setActiveTab(sequence.id.toString(), tabItems.length);
  };

  return (
    <DuplicateButton
      type="button"
      onClick={handleDuplicateLatestTab}
      aria-label={t`Duplicate latest tab`}
      title={t`Duplicate latest tab`}
      className={className}
    >
      <PlusIcon width={20} height={20} />
    </DuplicateButton>
  );
};
